import {Brick, registerBrick} from 'olympe';

export default class JSONStringify extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} object
     * @param {function(string)} setStringified
     */
    update($, [object], [setStringified]) {
        setStringified(JSON.stringify(object));
    }
}

registerBrick('01857d7687df5b0f0156', JSONStringify);
